<template>
  <div class="d-flex align-self-center">
    <span
        class="image-placeholder"
        :style="avatarStyle"
    ></span>
  </div>
</template>

<script>
export default {
  props: ['avatarURL', 'size'],

  computed: {
    avatar () {
      return this.avatarURL ?? '/images/Default.png';
    },

    avatarStyle () {
      const style = {
        backgroundImage: `url('${this.avatar}')`,
      };

      if (!this.size) {
        return style;
      }

      style['width'] = `${this.size}px`;
      style['height'] = `${this.size}px`;

      return style;
    },
  },
};
</script>
